document.addEventListener('DOMContentLoaded', function() {
  const nav = document.getElementById('CustomMobileNav');
  if (!nav) return;

  const originalMenuTrigger = document.querySelector('.burger-js');
  if (originalMenuTrigger) {
    const cleanMenuTrigger = originalMenuTrigger.cloneNode(true);
    originalMenuTrigger.parentNode.replaceChild(cleanMenuTrigger, originalMenuTrigger);
    cleanMenuTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openNav();
    });
  }

  let navigationHistory = [];
  let currentMenuHandle = 'mobile-nav-women';

  const closeBtn = nav.querySelector('.custom-mobile-nav__close-btn');
  const backBtn = nav.querySelector('.custom-mobile-nav__back-btn');
  const navTitle = nav.querySelector('.custom-mobile-nav__title');
  const headerLogo = nav.querySelector('.custom-mobile-nav__header-logo');
  const tabs = nav.querySelectorAll('.custom-mobile-nav__tab-btn');
  const level1 = nav.querySelector('[data-level="1"]');
  const level2 = nav.querySelector('[data-level="2"]');
  const level2Content = nav.querySelector('.custom-mobile-nav__submenu-content');

  function openNav() {
    showMainTabs();
    nav.classList.add('is-open');
    document.body.classList.add('custom-nav-open');
  }

  function closeNav() {
    nav.classList.add('is-closing');
    nav.classList.remove('is-open');

    setTimeout(() => {
      nav.classList.remove('is-closing');
      document.body.classList.remove('custom-nav-open');
      // Redirect removed (NO PAGE CHANGE)
    }, 300);
  }

  function showMainTabs() {
    navigationHistory = [];
    level1.style.display = 'block';
    level2.style.display = 'none';
    backBtn.style.display = 'none';
    navTitle.textContent = '';
    navTitle.style.cursor = 'default';
    navTitle.dataset.url = '';

    if (headerLogo) headerLogo.style.display = 'block';
  }

  function renderLevel(content, title, url) {
    level2Content.innerHTML = '';
    const clone = content.cloneNode(true);
    clone.style.display = 'block';
    level2Content.appendChild(clone);

    navTitle.textContent = title || '';
    navTitle.style.cursor = url ? 'pointer' : 'default';
    navTitle.dataset.url = url || '';

    level1.style.display = 'none';
    level2.style.display = 'block';
    backBtn.style.display = 'block';

    if (headerLogo) headerLogo.style.display = 'none';
  }

  function goBack() {
    showMainTabs();
  }

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeNav();
  });

  backBtn.addEventListener('click', goBack);

  navTitle.addEventListener('click', () => {
    if (navTitle.dataset.url) window.location.href = navTitle.dataset.url;
  });

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const handle = tab.dataset.menuHandle;

      if (handle) {
        currentMenuHandle = handle;
      }

      const allPanels = nav.querySelectorAll('.custom-mobile-nav__panel');
      allPanels.forEach(p => p.classList.remove('active'));

      const targetPanel = nav.querySelector(`.custom-mobile-nav__panel[data-menu-handle="${handle}"]`);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });

  nav.addEventListener('click', (e) => {
    const targetLink = e.target.closest('a[data-has-submenu="true"]');
    if (!targetLink) return;

    e.preventDefault();
    const submenuContainer = targetLink.nextElementSibling;

    if (submenuContainer && submenuContainer.classList.contains('custom-mobile-nav__submenu-data')) {
      const title = targetLink.dataset.title || targetLink.textContent.trim();
      const url = targetLink.href;
      renderLevel(submenuContainer, title, url);
    }
  });

  if (tabs.length > 0) {
    tabs[0].click();
  }
});